import { useCallback, RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import useUiuxStore from "src/store/useUiuxStore";
import { focusToCell } from "src/utils/grid/GridHandlerContent";
import { EQM4010_R01DetailDto } from "../Dto_EQM4010_R01";

interface UseEQM4010_R01ModalProps {
	updateEQM4010_R01Detail: (index: number, data: EQM4010_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<EQM4010_R01DetailDto> | null>;
}

export function useEQM4010_R01Modal({
	updateEQM4010_R01Detail,
	gridRef,
}: UseEQM4010_R01ModalProps) {
	const { setCodeSearchModalProps } = useUiuxStore();

	const handlePopupClose = useCallback(() => {
		if (gridRef.current?.api) {
			gridRef.current.api.stopEditing();
		}
	}, [gridRef]);

	const settingCodeSearchModalProps = useCallback(
		(
			category: string,
			search: string,
			isInfo: boolean,
			handleFoucsId: string,
			rowData: EQM4010_R01DetailDto,
			valueIndex: number,
			originalData?: EQM4010_R01DetailDto,
		) => {
			const baseData = originalData ?? rowData;

			setCodeSearchModalProps({
				category,
				search,
				formName: "EQM4010_R01",
				isInfo,
				handleFoucsId,
				wrapperOption: { size: "md", width: 50, overlay: true },
				onClear: () => {
					updateEQM4010_R01Detail(valueIndex, {
						...baseData,
						cleanWorker: "",
						cleanWorkerNm: "",
						isModified: true,
					});
					handlePopupClose();
				},
				onConfirm: (data: any) => {
					updateEQM4010_R01Detail(valueIndex, {
						...rowData,
						cleanWorker: data.empNo || "",
						cleanWorkerNm: data.empNm || "",
						isModified: true,
					});

					setTimeout(() => {
						if (!gridRef.current) return;
						focusToCell(gridRef, valueIndex, "remark");
					}, 100);
				},
			});
		},
		[setCodeSearchModalProps, updateEQM4010_R01Detail, gridRef, handlePopupClose],
	);

	return { settingCodeSearchModalProps, handlePopupClose };
}
